import {
  getCurrentPage,
  setCurrentPage,
  getInfo,
  getChosenAddons,
  getTotalTime,
  getMessage,
  getTotalPrice,
  getChosenFacility,
  getOrder,
  setOrder,
  getChosenService,
  getChosenDate,
  getServiceCode,
  getKey,
} from "./general.js";
import * as listener from "./listeners.js";
var url;
var block = document.querySelector(".kobra-block");
const event = new Event("pageChange");

export function initNextBtn() {
  const nextButtons = block.querySelectorAll("button.next");
  if (nextButtons.length > 0) {
    nextButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        if (btn.dataset.external) {
          window.location.href = btn.dataset.external;
          return;
        }

        const currentPage = getCurrentPage() + 1;
        setCurrentPage(currentPage);
        block.querySelector(".page--active").classList.remove("page--active");
        block.querySelector(".page--" + currentPage).classList.add("page--active");

        document.dispatchEvent(event);
        removeEventlisteners(currentPage - 1);
      });
    });
  }
}
export function initPrevBtn() {
  const prevButton = block.querySelectorAll("button.prev");
  if (prevButton.length > 0) {
    prevButton.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const currentPage = getCurrentPage() - 1;
        setCurrentPage(currentPage);
        block.querySelector(".page--active").classList.remove("page--active");
        block.querySelector(".page--" + currentPage).classList.add("page--active");

        document.dispatchEvent(event);
      });
    });
  }
}

export function setFocus() {
  const findFirstFocusableElement = (container) => {
    return Array.from(container.getElementsByTagName("*")).find(isFocusable);
  };
  const isFocusable = (item) => {
    if (item.tabIndex < 0) {
      return false;
    }
    switch (item.tagName) {
      case "A":
        return !!item.href;
      case "INPUT":
        return item.type !== "hidden" && !item.disabled;
      case "SELECT":
      case "TEXTAREA":
      case "BUTTON":
        return !item.disabled;
      default:
        return false;
    }
  };

  const firstEle = findFirstFocusableElement(document.querySelector(".page--active"));
  if (firstEle) {
    firstEle.focus();
  } else {
    // Om inget fokuserbart element hittas, leta i footer istället. Där bör "tillbaka"-knappen hittas
    findFirstFocusableElement(document.querySelector(".page__footer")).focus();
  }
}

export function lockButtons() {
  if (block) {
    block.querySelectorAll("button.next").forEach((btn) => {
      btn.disabled = true;
    });
  }
}

export function unlockButtons() {
  if (block) {
    block.querySelectorAll("button.next").forEach((btn) => {
      btn.disabled = false;
    });
  }
}

export function addToUrl(name, newValue, multipleValues) {
  url = new URL(window.location.href);
  const value = url.searchParams.get(name);

  if (multipleValues) {
    if (url.searchParams.has(name) && value !== "") {
      if (value.match(new RegExp("(^)" + newValue + "(\,|$)")) !== null) {
        url.searchParams.set(name, value.replace(new RegExp("(^)" + newValue + "(\,|$)"), ""));
      } else if (value.match(new RegExp("(\,)" + newValue + "(\,|$)")) !== null) {
        url.searchParams.set(name, value.replace(new RegExp("(\,)" + newValue + "(\,|$)"), ","));
      } else {
        url.searchParams.set(name, value + newValue + "\,");
      }
    } else {
      url.searchParams.set(name, newValue + "\,");
    }
  } else {
    url.searchParams.set(name, newValue);
  }
  window.history.replaceState(null, null, url);
}
export function getFromUrl(name) {
  if (url) {
    return url.searchParams.get(name);
  } else {
    return new URL(window.location.href).searchParams.get(name);
  }
}
export function removeFromUrl(name) {
  url = new URL(window.location.href);
  url.searchParams.delete(name);
  window.history.replaceState(null, null, url);
}

function removeEventlisteners(page) {
  if (page === 1) {
    document.querySelector('#kobra-form input[name="regno"]').removeEventListener("input", listener.regnoListener);
  }
  if (page === 2) {
    document.querySelectorAll('input[type="radio"][name="facility"]').forEach((radio) => {
      radio.removeEventListener("change", listener.facListener);
    });
  }
  if (page === 3) {
    document.querySelectorAll('input[type="radio"][name="service"]').forEach((radio) => {
      radio.removeEventListener("change", listener.serviceListener);
    });
    document.querySelectorAll(".services__service__top__left .readmore").forEach((opener) => {
      opener.removeEventListener("click", listener.serviceOpenerListener);
    });
  }
  if (page === 4) {
    document.querySelectorAll('input[type="checkbox"][name="addon"]').forEach((checkbox) => {
      checkbox.removeEventListener("change", listener.addonListener);
    });
  }
  if (page === 5) {
    document.querySelectorAll(".timeslots__time").forEach((time) => {
      time.removeEventListener("change", listener.timeListener);
    });
  }
}

export function createOrder(form) {
  const vehicle = getInfo();

  const addons = getChosenAddons();
  let loanerCar = false;
  let services = [getChosenService()];
  if (addons && addons.length > 0) {
    services = services.concat(addons);

    if (addons.findIndex((addon) => addon.loanerCar) > -1) {
      loanerCar = true;
    }
  }

  services = services.filter((value, index, self) => index === self.findIndex((t) => t.name === value.name));

  let formattedServices = [];
  services.forEach((service) => {
    formattedServices.push({
      productId: service.productId.toString(),
      name: service.name,
      description: service.short_desc,
      resourceDemand: service.resourceDemand,
      price: service.price,
      priceCode: 0,
    });
  });

  let campaign = form.querySelector("#campaign").value;
  if (campaign && campaign !== "") {
    formattedServices.push({
      productId: "",
      kobraProductId: "Kampanjkod " + campaign,
      name: "Kampanjkod " + campaign,
      packageType: "C",
      addonPackage: false,
      description: "Kampanjkod " + campaign,
      resourceDemand: 0,
      price: 0,
      priceCode: 0,
    });
  }

  let serviceCode = getServiceCode();
  if (serviceCode && serviceCode !== "") {
    serviceCode = " Servicekod: " + serviceCode;
  }

  const date = getChosenDate();

  let phone = form.querySelector("#phone").value;
  if (!phone) {
    form.querySelector("#phone-error").classList.add("error-message-visible");
    return false;
  }
  form.querySelector("#phone-error").classList.remove("error-message-visible");
  phone = formatPhoneNumber(phone);
  if (!phone || phone === "") {
    return false;
  }

  const order = {
    bookingDate: date,
    bookingStart: date.includes("T00:00:00") ? "" : date,
    freeText: getMessage() + serviceCode,
    customerIsWaiting: form.querySelector("#contact_wait").checked,
    customer: {
      email: form.querySelector("#email").value,
      preferredWayOfContact: parseInt(form.querySelector('input[name="prefered_contact"]:checked').value),
      phoneHome: phone,
      phoneMobile: phone,
    },
    vehicle: {
      regNo: vehicle.regno,
      mileage: vehicle.mileage ?? 0,
      driverName: form.querySelector("#lastname").value + ", " + form.querySelector("#firstname").value,
      driverEmail: form.querySelector("#email").value,
      driverEmailIsMissing: false,
      driverPhoneHome: phone,
      driverPhoneMobile: phone,
    },
    products: formattedServices,
    totalPrice: getTotalPrice(),
    rentalCar: false,
    loanerCar: loanerCar,
  };

  setOrder(order);
  return order;
}

function formatPhoneNumber(phoneNumberString) {
  let cleaned = ("" + phoneNumberString).replace(/(^0|^\+46|^\+47|^\+45|^\+358|^46|^47|^45|^358)/, "");
  cleaned = cleaned.replace(/\D/g, "");
  if (cleaned) {
    return document.querySelector("#country-code").value + cleaned;
  }
  return null;
}

export function createOrderSummary() {
  const order = getOrder();
  const vehicle = getInfo();
  const service = getChosenService();
  const addons = getChosenAddons();
  const facility = getChosenFacility();
  const date = getChosenDate();
  const message = getMessage();
  const currentPage = getCurrentPage();

  if (order) {
    document.querySelectorAll(".order__container .info").forEach((info) => {
      info.style.display = "block";
    });

    document.querySelector("#order_firstname").textContent = order.vehicle.driverName.split(", ")[0];
    document.querySelector("#order_lastname").textContent = order.vehicle.driverName.split(", ")[1];
    document.querySelector("#order_email").textContent = order.vehicle.driverEmail;
    document.querySelector("#order_phone").textContent = order.vehicle.driverPhoneHome;

    const campaignProduct = order.products.findIndex((prod) => prod.name.includes("Kampanjkod"));
    if (campaignProduct >= 0) {
      document.querySelector("#order_campaign").textContent = order.products[campaignProduct].name.replace(
        "Kampanjkod ",
        "",
      );
    } else {
      document.querySelector("#order_campaign_heading").style.display = "none";
    }
  } else {
    document.querySelectorAll(".order__container .info").forEach((info) => {
      info.style.display = "none";
    });
  }

  if (vehicle) {
    document.querySelector("#car_regno").textContent = vehicle.regno;
    document.querySelector("#car_brand_model").textContent = vehicle.brand + ", " + vehicle.model;
    if (vehicle.mileage) {
      document.querySelector("#mileage_heading").style.display = "block";
      document.querySelector("#car_mileage").textContent = vehicle.mileage;
    } else {
      document.querySelector("#mileage_heading").style.display = "none";
      document.querySelector("#car_mileage").style.display = "none";
    }

    const campaignBanner = document.querySelector("#campaign-banner");
    if (campaignBanner) {
      const campaignBrand = campaignBanner.dataset.brand;

      if (campaignBrand) {
        if (campaignBrand.toLowerCase().includes(vehicle.brand.toLowerCase() + "|")) {
          campaignBanner.classList.add("campaign-banner--active");
        } else {
          campaignBanner.classList.remove("campaign-banner--active");
        }
      } else {
        campaignBanner.classList.add("campaign-banner--active");
      }
    }
  }

  if (service && service.slug === "other") {
    document.querySelector(".service__item.top").style.display = "block";
    if (message) {
      document.querySelector("#service_name").innerHTML = "Reparationsdiagnos/annat ärende: <br><i>" + message + "</i>";
    } else {
      document.querySelector("#service_name").textContent = "Reparationsdiagnos/annat ärende";
    }
  } else if (service) {
    document.querySelector(".service__item.top").style.display = "block";
    document.querySelector("#service_name").textContent = service.name;
    if (service.price !== "") {
      document.querySelector("#service_price").textContent = service.price + " kr";
    } else {
      document.querySelector("#service_price").textContent = "Pris på offert";
    }

    if (service.info_req && getServiceCode()) {
      document.querySelector("#service_code").style.display = "block";
      document.querySelector("#service_code").textContent = "Servicekod: " + getServiceCode();
    } else {
      document.querySelector("#service_code").style.display = "none";
    }
  } else {
    document.querySelector(".service__item.top").style.display = "none";
  }

  if (date) {
    document.querySelector(".date__item.top").style.display = "block";
    document.querySelector("#date_time").textContent = date.replace("T", " ").replace("Z", "").replace("00:00:00", "");
    if (addons.length > 0) {
      addons.forEach((addon) => {
        // if(addon.morning) {
        //     document.querySelector('#date_time').textContent += '(Lämnas innan kl 07)';
        // }
        if (addon.before) {
          document.querySelector("#date_time").textContent += "(Lämnas dagen innan)";
        }
      });
    }
  } else {
    document.querySelector(".date__item.top").style.display = "none";
  }

  if (facility) {
    document.querySelector("#facility_name").textContent = facility.title;
    document.querySelector("#facility_address").textContent = facility.address;
    document.querySelector("#facility_image").src = facility.image;
  }

  document.querySelectorAll("#chosen_addons tr").forEach((tr) => {
    tr.remove();
  });
  if (addons.length > 0) {
    addons.forEach((addon) => {
      if (addon.morning || addon.before || addon.name.includes("Kampanjkod")) return;

      let tr = document.createElement("tr");
      let td1 = document.createElement("td");
      let td2 = document.createElement("td");
      td1.textContent = addon.name;
      if (addon.price !== "") {
        td2.textContent = addon.price + " kr";
      } else {
        td2.textContent = "Pris på offert";
      }
      tr.append(td1);
      tr.append(td2);
      document.querySelector("#chosen_addons").append(tr);
    });
    if (getTotalPrice() !== 0 && Number.isInteger(getTotalPrice())) {
      let tr = document.createElement("tr");
      let td1 = document.createElement("th");
      let td2 = document.createElement("th");
      td1.textContent = "Totalt";
      td2.textContent = getTotalPrice() + " kr";
      tr.append(td1);
      tr.append(td2);
      document.querySelector("#chosen_addons_footer").append(tr);
    } else {
      document.querySelector("#chosen_addons_footer").style.display = "none";
    }
  } else {
    let tr = document.createElement("tr");
    let td = document.createElement("td");
    td.classList.add("no-addons");
    td.textContent = "Inga tillval valda.";
    tr.append(td);
    document.querySelector("#chosen_addons").append(tr);
  }

  document.querySelectorAll(".order__item__edit").forEach((btn) => {
    if (parseInt(btn.dataset.page) < currentPage && currentPage < 7) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  });
}

export async function sendOrder(order) {
  const form = new FormData();
  const facility = getChosenFacility();
  form.append("action", "nobox_send_order");
  form.append("order", JSON.stringify(order));
  form.append("facility", facility.title);
  form.append("key", getKey());

  const params = new URLSearchParams(form);

  let resp;
  await fetch(horizon.ajaxUrl, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Cache-Control": "no-cache",
    },
    body: params,
  })
    .then((response) => response.json())
    .then((data) => {
      resp = data.data;
    });

  return resp;
}

export function activateExternalLink(url, text) {
  const button = document.querySelector(".page__footer .container .button.next");
  button.setAttribute("data-external", url);
  if (text) {
    button.textContent = text;
  }
}

export function deactivateExternalLink() {
  const button = document.querySelector(".page__footer .container .button.next");
  button.removeAttribute("data-external");
  button.textContent = "Gå vidare";
}
